import { ActionConsts } from "@Definitions/ActionConsts";
import { IAddress, IMeResponse } from "@Interfaces/Api/user";
import { RootState } from "@Interfaces/redux";
import { apiUser, me } from "@Services/API/IndividualApi's/User";
import { AnyAction, Dispatch } from "redux";

export const UserActions = {
  getMyDetails: () => {
    return async (dispatch: Dispatch) => {
      try {
        const myDetails = await apiUser.getMYDetails();
        dispatch({ type: ActionConsts.User.GetMyDetails, payload: myDetails });
      } catch (err) {
        console.log(err);
      }
    };
  },
  setSelectedAddress: (address: IAddress) => {
    return { type: ActionConsts.User.setSelectedAddress, payload: address };
  },
  addNewAddress: (address: Omit<IAddress, "_id">, isDefault: boolean) => {
    return async (dispatch: Dispatch<any>, getState: () => RootState) => {
      try {
        const userDetails = getState().UserReducer.user;
        const preShippingAddresses = userDetails?.shippingAddresses;
        if (preShippingAddresses) {
          // current address is choosen to be as default then make isDefault=false for previous
          // default address
          if (isDefault) {
            const idx = preShippingAddresses.findIndex(
              (address) => address.isDefault
            );
            if (idx !== -1) {
              preShippingAddresses[idx].isDefault = false;
            }
          }
          const newShippingAddresses = [...preShippingAddresses, address];
          const data: IMeResponse = {
            ...userDetails,
            shippingAddresses: newShippingAddresses,
          };
          const response = await apiUser.updateUserProfile(data);
          dispatch(UserActions.getMyDetails());
        }
      } catch (err) {
        console.log(err);
      }
    };
  },
  editAddress: (address: IAddress, isDefault: boolean) => {
    return async (dispatch: Dispatch<any>, getState: () => RootState) => {
      try {
        const userDetails = getState().UserReducer.user;
        const preShippingAddresses = userDetails?.shippingAddresses;
        if (preShippingAddresses) {
          // current address is choosen to be as default then make isDefault=false for previous
          // default address
          if (isDefault) {
            const idx = preShippingAddresses.findIndex(
              (item) => item.isDefault && address._id !== item._id
            );
            if (idx !== -1) {
              preShippingAddresses[idx].isDefault = false;
            }
          }
          const idx = preShippingAddresses.findIndex(
            (item) => item._id === address._id
          );
          if (idx !== -1) {
            preShippingAddresses[idx] = address;

            const data: IMeResponse = {
              ...userDetails,
              shippingAddresses: preShippingAddresses,
            };
            const response = await apiUser.updateUserProfile(data);
            dispatch(UserActions.getMyDetails());
          }
        }
      } catch (err) {
        console.log(err);
      }
    };
  },
  updateUserInfo: (
    userInfo: Pick<IMeResponse, "email" | "name" | "phoneNumber">
  ) => {
    return async (dispatch: Dispatch<any>, getState: () => RootState) => {
      try {
        const userDetails = getState().UserReducer.user;
        if (userDetails) {
          const data: IMeResponse = {
            ...userDetails,
            ...userInfo,
          };
          const response = await apiUser.updateUserProfile(data);
          dispatch(UserActions.getMyDetails());
        }
      } catch (err) {
        console.log(err);
      }
    };
  },
  deleteAddress: (_id: string) => {
    return async (dispatch: Dispatch<any>, getState: () => RootState) => {
      try {
        const userDetails = getState().UserReducer.user;
        const preShippingAddresses = userDetails?.shippingAddresses;
        if (preShippingAddresses) {
          const idx = preShippingAddresses.findIndex(
            (address) => address._id === _id
          );
          if (idx !== -1) {
            preShippingAddresses.splice(idx, 1);
            const data: IMeResponse = {
              ...userDetails,
              shippingAddresses: preShippingAddresses,
            };
            const response = await apiUser.updateUserProfile(data);
            dispatch(UserActions.getMyDetails());
          }
        }
      } catch (err) {
        console.log(err);
      }
    };
  },
};
